import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import { SearchCode } from 'lucide-react';
import { PageShareTitle } from '../../lib/shareTitle';
import { getStoredFunMode, translate } from '../i18n';

export const queryRouteRef = createRouteRef();

export const queryPage = PageBlueprint.make({
  params: {
    path: '/query',
    // Non-component config (evaluated once at extension registration), so
    // this reads the fun-mode flag directly instead of the useT() hook — see
    // the i18n module's non-component-code note.
    title: translate('query.page.title', getStoredFunMode()),
    icon: <SearchCode size={20} strokeWidth={2} />,
    routeRef: queryRouteRef,
    noHeader: true,
    loader: () =>
      import('./QueryPage').then(m => (
        <PageShareTitle title="Query">
          <m.QueryPage />
        </PageShareTitle>
      )),
  },
});

export const queryPlugin = createFrontendPlugin({
  pluginId: 'query',
  extensions: [queryPage],
});
